import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=bfd81706&scoped=true"
import script from "./Options.vue?vue&type=script&lang=js"
export * from "./Options.vue?vue&type=script&lang=js"
import style0 from "./Options.vue?vue&type=style&index=0&id=bfd81706&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd81706",
  null
  
)

export default component.exports